'use client';
import CDNImage from '@/components/cdnImage/cdnImage';
import SafeLink from '@/components/SafeLink';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import style from './style.module.scss';

export default function Module({ moduleData, pageName }: { moduleData: any; pageName: string }) {
  const pageConfig: any = {};

  const initConfig = (moduleData: any) => {
    pageConfig.data = moduleData.dataBatch?.brandConfig?.filter((item: any) => item.brand) || [];
    pageConfig.title = moduleData.dataStyle?.title?.title || '';
    pageConfig.moduleCode = moduleData.moduleCode || ''; // 动态获取类名
  };
  initConfig(moduleData);

  if (!pageConfig.data) {
    return null;
  }

  // 根据数据长度判断使用单行还是双行布局
  const isSingleRow =
    pageConfig.moduleCode === 'small-1-explore-brands' ||
    (pageConfig.moduleCode === 'small-2-explore-brands' && pageConfig.data.length < 12);
  const gridTemplateRows = isSingleRow ? '60px' : 'repeat(2, 60px)';

  return (
    <div className={pageConfig.moduleCode ? style[pageConfig.moduleCode] : ''}>
      {pageConfig.title ? (
        <>
          <div className={style.header}>
            <div className={style.title}>{pageConfig.title}</div>
          </div>
        </>
      ) : null}

      {/* 双行滚动容器结构 */}
      <div
        className={style.scrollContainer}
        // style={{ paddingTop: pageConfig.title ? '0' : '12px' }}
      >
        <div className={style.scrollContent} style={{ gridTemplateRows }}>
          {pageConfig.data.map((item: any, index: number) => (
            <SafeLink
              href={`/store/${item.brand.shopId}`}
              key={item.brand.shopId}
              onClick={(e) => {
                spmTrackingUtils.spmClick({
                  spm: `a0145.b002244.c00002472.${index + 1}`,
                  page_id: 'Mini_Hp',
                  event_id: 'Home_Mini_Hp_Brands',
                  target: e.target as HTMLElement,
                  json_param: JSON.stringify({
                    index: index,
                    shopid: item.brand.shopId,
                    brandid: '-100',
                    Mini_Hp_Name: pageName || 'home',
                  }),
                });
              }}
            >
              <div
                className={style.item}
                data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                data-exp={JSON.stringify({
                  spm: `a0145.b002244.c00002472.${index + 1}`,
                  page_id: 'Mini_Hp',
                  event_id: 'Home_Mini_Hp_Brands_Expo',
                  json_param: {
                    index: index,
                    shopid: item.brand.shopId,
                    brandid: '-100',
                    Mini_Hp_Name: pageName || 'home',
                  },
                })}
              >
                <div className={style.bg}>
                  <CDNImage
                    src={item?.brand?.shopIcon || ''}
                    width={52}
                    height={52}
                    alt={item?.brand?.shopName || ''}
                  />
                </div>
              </div>
            </SafeLink>
          ))}
        </div>
      </div>
    </div>
  );
}
